import { put, takeLatest } from 'redux-saga/effects';
import { NavigationBarActions, darkModeSetting } from '../../constants';

// Loads in code and dark mode settings from local storage
function* loadLocalStorageTheme() {
  if (window.localStorage) {
    // All local storage is saved as string so we convert the boolean string to get a boolean value
    const darkMode = localStorage.getItem(darkModeSetting);
    if (darkMode) {
      yield put({
        type: NavigationBarActions.UPDATE_THEME,
        payload: darkMode.toLowerCase() === 'true',
      });
    }
  }
}

function* setLocalStorageTheme(action) {
  // Save the code in action content to local storage
  if (window.localStorage) {
    yield localStorage.setItem(darkModeSetting, action.darkToggle);
  }
}

// This saga handles changes to the navigation bar
export default function* navigationBarSaga() {
  yield takeLatest(NavigationBarActions.ON_LOAD_THEME, loadLocalStorageTheme);
  yield takeLatest(NavigationBarActions.SAVE_THEME, setLocalStorageTheme);
}
